// Location landing pages. Each ranks independently for
// "video production [city]" and similar local search queries.
// IMPORTANT copy rule: we never say we're "based" anywhere — pages
// focus on coverage ("we cover the X area") so the visitor learns
// only that we film there.

export const LOCATIONS = [
  {
    slug: "video-production-manchester",
    city: "Manchester",
    cityRegion: "Greater Manchester",
    h1Lead: "Video Production Manchester",
    subhead:
      "Yellow Video Production covers the Manchester area for brand films, corporate video, motion graphics and drone. Fixed-price quote in 4 working hours.",
    intro:
      "We've been producing video for Manchester businesses since 2012 — product films in Salford, corporate shoots in Spinningfields, event coverage in the Northern Quarter and drone work across Greater Manchester. Our full crew delivers a single fixed price, no travel surcharge for anything inside the M60.",
    workedWith: ["Aldi", "Co-op", "Onward Homes", "Hoya Lens", "Argos"],
    keywords:
      "video production manchester, videographer manchester, video production company manchester, corporate video manchester, brand video manchester, video production agency manchester, manchester video production company",
    metaDesc:
      "Video production in Manchester — brand films, corporate video, motion graphics & drone. Yellow covers Greater Manchester with a fixed-price quote in 4 hours and free stills.",
    points: [
      "Covering the entire Manchester area, including Salford, Stockport, Trafford and Bolton",
      "Filmed for major Manchester brands including Aldi, Co-op and Onward Homes",
      "No travel surcharge for projects inside the M60",
      "Drone, photography and animation all delivered in-house",
      "Fixed-price quote in 4 working hours, no agency markup",
    ],
    nearby: ["Salford", "Stockport", "Trafford", "Bolton", "Oldham"],
  },
  {
    slug: "video-production-wirral",
    city: "Wirral",
    cityRegion: "Merseyside",
    h1Lead: "Video Production Wirral",
    subhead:
      "Yellow Video Production covers the Wirral peninsula for brand films, corporate video and drone footage across Birkenhead, West Kirby, Bromborough and beyond.",
    intro:
      "Yellow has been filming for Wirral businesses and organisations for over a decade. From Bromborough industrial estate to West Kirby beach, our crew works across the peninsula regularly. Local coverage, transparent pricing, no travel fees on the Wirral.",
    workedWith: ["NHS", "Onward Homes", "Liverpool John Moores University", "MADE"],
    keywords:
      "video production wirral, videographer wirral, video production company wirral, corporate video wirral, video production birkenhead, wirral video company, video production west kirby",
    metaDesc:
      "Video production covering the Wirral — filming in Birkenhead, West Kirby, Bromborough & across the peninsula. Fixed quote in 4 hours, free stills photography included.",
    points: [
      "Full coverage across the Wirral peninsula",
      "Filmed across Birkenhead, West Kirby, Bromborough and Heswall",
      "No travel charges on the peninsula",
      "CAA-licensed drone for Wirral coast, parks and industrial sites",
      "Filming across Merseyside since 2012, hundreds of projects delivered",
    ],
    nearby: ["Birkenhead", "West Kirby", "Heswall", "Bromborough", "Bebington", "Wallasey"],
  },
  {
    slug: "video-production-chester",
    city: "Chester",
    cityRegion: "Cheshire",
    h1Lead: "Video Production Chester",
    subhead:
      "Yellow Video Production covers Chester and Cheshire for brand films, corporate video and drone. Long-standing partner of the University of Chester.",
    intro:
      "We've worked with the University of Chester, local SMEs and national brands shooting on location in the city. Our crew is in Chester regularly — from the Roman walls and Eastgate to Chester Business Park — with no extra fees within Cheshire West for most projects. Talk to us about your brief and we'll send a fixed quote within 4 working hours.",
    workedWith: ["University of Chester", "Argos", "Aldi", "Liverpool Hope University", "Hoya Lens"],
    keywords:
      "video production chester, videographer chester, video production company chester, corporate video chester, chester video production, video production cheshire, brand video chester",
    metaDesc:
      "Video production covering Chester & Cheshire since 2012. Long-standing partner of the University of Chester. Fixed quote in 4 hours, free stills photography.",
    points: [
      "Covering Chester city centre and the wider Cheshire area",
      "Long-standing partner of the University of Chester for promotional film",
      "Filmed across the Roman walls, Eastgate, Chester Business Park and beyond",
      "CAA-licensed drone for Chester architecture and event filming",
      "No travel surcharge for projects within Cheshire West & Chester",
    ],
    nearby: ["Ellesmere Port", "Northwich", "Frodsham", "Tarporley", "Hawarden"],
  },
  {
    slug: "video-production-north-wales",
    city: "North Wales",
    cityRegion: "North Wales",
    h1Lead: "Video Production North Wales",
    subhead:
      "Yellow Video Production covers North Wales for brand films, corporate video and drone. Filming across Wrexham, Llandudno, Conwy, Anglesey and the Snowdonia coast.",
    intro:
      "Yellow has been filming in North Wales for over a decade — coastal property shoots in Llandudno, industrial drone footage in Wrexham and Deeside, brand films across Conwy and Anglesey. Full crew, transparent pricing, no London-agency premiums.",
    workedWith: ["Permaroof", "Onward Homes", "Cancer Research UK", "Aldi", "Hoya Lens"],
    keywords:
      "video production north wales, videographer north wales, video production company north wales, video production wrexham, video production llandudno, corporate video north wales, video production conwy, video production deeside",
    metaDesc:
      "Video production covering North Wales — Wrexham, Llandudno, Conwy, Deeside, Anglesey & Snowdonia. Fixed quote in 4 hours, free stills photography included.",
    points: [
      "Full coverage across North Wales",
      "CAA-licensed drone for coast, mountain and industrial site filming",
      "Filmed across Wrexham, Llandudno, Deeside, Conwy and Anglesey",
      "Bilingual subtitle delivery available on request",
      "Travel costed transparently in your fixed quote, no surprises",
    ],
    nearby: ["Wrexham", "Llandudno", "Conwy", "Deeside", "Bangor", "Colwyn Bay", "Anglesey"],
  },
];

export function getLocation(slug) {
  return LOCATIONS.find((l) => l.slug === slug);
}
